import {SPACE_ACTIVITIES, BOOKING, space, SAVINGS, NEWSLETTER} from '../../../api/apiPaths';
import { get, post,deleteSpace, put, getSampleList } from '../../../api/commonAPI';
import { deleteImageFromCloudinery } from '../../../api/imagesApi';
import toastr from 'toastr';
import * as Actions from './SpaceActionTypes';
import { setDescriptionError } from '../../../redux/actions/uistate';

export const getSpaceActivities = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACE_ACTIVITIES
    });
    get(SPACE_ACTIVITIES)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SPACE_ACTIVITIES_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SPACE_ACTIVITIES_FAILS,
          payload: error
        });
      });
  };
};

export const resetSpaceFormData = () => ({
  type: Actions.RESET_SPACE_FORM_DATA
});

export const deleteImage = etag => {
  return dispatch => {
    dispatch({
      type: Actions.DELETE_IMAGE
    });

    // deleteImageFromCloudinery(etag).then(res => {
    // });
  };
};

export const getApplicableTaxes = countryShortCode => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_TAX
    });
    get(`${BOOKING}tax?country=${countryShortCode}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_TAX_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_TAX_FAILS,
          payload: error
        });
      });
  };
};

export const getCancellationPolicies = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_CANCELLATION_POLICIES
    });
    get(`${space}/cancellation-policy`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_CANCELLATION_POLICIES_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_CANCELLATION_POLICIES_FAILS,
          payload: error
        });
      });
  };
};


export const getPricingOptions = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_PRICING_OPTIONS
    });
    get(`${space}/charging-type`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_PRICING_OPTIONS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_PRICING_OPTIONS_FAILS,
          payload: error
        });
      });
  };
};

export const getAmenities = (country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_AMENITIES
    });
    get(`${space}/amenity-map?country=${country}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_AMENITIES_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_AMENITIES_FAILS,
          payload: error
        });
      });
  };
};

export const getAddons = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_ADDONS
    });
    get(`${space}/add-on `)
      .then(res => {
        dispatch({
          type: Actions.FETCH_ADDONS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_ADDONS_FAILS,
          payload: error
        });
      });
  };
};

export const getRules = (country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_RULES
    });
    get(`${space}/space-rules-map?country=${country}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_RULES_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_RULES_FAILS,
          payload: error
        });
      });
  };
};

export const submitSpaceDetails = (value, resetFormData, setIsSaving) => {
  return dispatch => {
    dispatch({
      type: Actions.SUBMIT_SPACE_DETAILS
    });
    setIsSaving(true);
    post(`${space}`, value)
      .then(res => {
        toastr.success('Successfully saved')
        resetFormData();
        dispatch(setDescriptionError(false))
      })
      .catch(error => {
        if(error.response?.data?.errors?.length){
          for (let i = 0; i < error.response.data.errors.length; i++) {
            toastr.error(error.response.data.errors[i])            
          }
        }else{
          toastr.error("Failed to save")
        }
      })
      .finally(() => {
        setIsSaving(false);
      });
  };
};
export const submitSpaceDetailsMeet = (value, resetFormData, setIsSaving) => {
  return dispatch => {
    dispatch({
      type: Actions.SUBMIT_SPACE_DETAILS
    });
    setIsSaving(true);

    post(`${space}/meet`, value)
      .then(res => {
        toastr.success('Successfully saved')
        resetFormData();
        dispatch(setDescriptionError(false))
      })
      .catch(error => {
        if(error.response?.data?.errors?.length){
          for (let i = 0; i < error.response.data.errors.length; i++) {
            toastr.error(error.response.data.errors[i])            
          }
        }else{
          toastr.error("Failed to save")
        }
      }).finally(() => {
        setIsSaving(false);
      });
  };
};
export const submitSpaceDetailsTrain = (value, resetFormData, setIsSaving) => {
  return dispatch => {
    dispatch({
      type: Actions.SUBMIT_SPACE_DETAILS
    });
    setIsSaving(true);

    post(`${space}/train`, value)
      .then(res => {
        toastr.success('Successfully saved');
        resetFormData();
        dispatch(setDescriptionError(false))
      })
      .catch(error => {
        if(error.response?.data?.errors?.length){
          for (let i = 0; i < error.response.data.errors.length; i++) {
            toastr.error(error.response.data.errors[i])            
          }
        }else{
          toastr.error("Failed to save")
        }
      }).finally(() => {
        setIsSaving(false);
      });
  };
};

export const getSeatingArrangement = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SEATING_ARRANGEMENT
    });
    get(`${space}/seat-arrangement`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SEATING_ARRANGEMENT_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SEATING_ARRANGEMENT_FAILS,
          payload: error
        });
      });
  };
};

export const getSavings = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SAVINGS
    });
    get(`${SAVINGS}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SAVINGS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SAVINGS_FAILS,
          payload: error
        });
      });
  };
};

export const getSpaceData = (page, size, email, country, status) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACEDATA
    });
    let url = `${space}?page=${page}&size=${size}&dataView=TABLE_VIEW`
    if(email) url = `${url}&q=${email}`;
    if(status) url = `${url}&status=${status}`;
    if(country) url = `${url}&country=${country}`;
    get(url)
        .then(res => {
          dispatch({
            type: Actions.FETCH_SPACEDATA_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_SPACEDATA_FAILS,
            payload: error
          });
        });
  };
};

export const fetchSpaceDetails =  (id, category, setFetchedData) => {
  return  dispatch => {
    dispatch({
      type: Actions.FETCH_SPACEDETAILS
    });
    
      let url;
      if(category === 'Train')
        url = `${space}/train/${id}`;
      else if(category === 'Meet' || category === 'Shoot')
        url = `${space}/meet/${id}`;
      else
        url = `${space}/${id}`;

      get(url)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SPACEDETAILS_SUCCESS,
          payload: res.data
        });
        setFetchedData(true)
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SPACEDETAILS_FAILS,
          payload: error
        });
      });

  };
};

export const fetchPlatformData =  (id, category, setFetchedData) => {
  return  dispatch => {
    dispatch({
      type: Actions.FETCH_PLATFORMDATA
    });
    
      let url = `api/md/platform`;

      get(url)
      .then(res => {
        dispatch({
          type: Actions.FETCH_PLATFORMDATA_SUCCESS,
          payload: res.data
        });
        setFetchedData(true)
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_PLATFORMDATA_FAILS,
          payload: error
        });
      });

  };
};

export const updateSpaceDetails =  (value, version, category, fetchSpaceDetails, setFetchedData, setIsSaving, resetFormData) => {
  return  dispatch => {
    dispatch({
      type: Actions.UPDATE_SPACE_DETAILS
    });
    setIsSaving(true);
    const versionHeader = {'If-Match': version};
    let url;
    if(category === 'Train')
      url = `api/space/train`;
      else if(category === 'Meet' || category === 'Shoot')
      url = `api/space/train`;
    else
      url = `api/space`;

      put(url, value, versionHeader)
      .then(res => {
        toastr.success('Successfully saved');
        // resetFormData()
        dispatch(fetchSpaceDetails(value.id, category, setFetchedData));

        setTimeout(() => {
          window.location.href = '/dashboard/space/space';
        }, 1500);
      })
      .catch(error => {
        toastr.error("Failed to save");
      }).finally(() => {
        setIsSaving(false);
      });

  };
};

export const deleteSpaceDetails = (id,category,page) => {
    return dispatch => {
        dispatch({
            type: Actions.DELETE_SPACEDETAILS
        });

        let url;
        if(category === 'Train')
            url = `${space}/train/${id}`;
        else if(category === 'Meet' || category === 'Shoot')
            url = `${space}/meet/${id}`;
        else
            url = `${space}/${id}`;

        deleteSpace(url)
            .then(res => {
                toastr.success('Successfully deleted')
                dispatch(getSpaceData(page,5));
            })
            .catch(error => {
                if(error.response?.data?.errors?.length){
                    for (let i = 0; i < error.response.data.errors.length; i++) {
                        toastr.error(error.response.data.errors[i])
                    }
                }else{
                    toastr.error("Failed to delete")
                }
            });
    };
};

export const getPackageTypes = (country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_PACKAGE_TYPE
    });
    get(`${space}/package-type-map?country=${country}`)
        .then(res => {
          dispatch({
            type: Actions.FETCH_PACKAGE_TYPE_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_PACKAGE_TYPE_FAILS,
            payload: error
          });
        });
  };
};

export const filterSpaceName = (page, size, spacename, country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_FILTERSPACENAME
    });
    let url = `${space}/filter?page=${page}&size=${size}&q=${spacename}&country=${country}`
    get(url)
      .then(res => {
        dispatch({
          type: Actions.FETCH_FILTERSPACENAME_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_FILTERSPACENAME_FAILS,
          payload: error
        });
      });
  };
};

export const getWeeklyPicks = (country)=> {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_WEEKLY_PICKS
    });
    get(`${space}/weekly-picks?country=${country}`)
      .then(res => {
        dispatch({
          type:Actions.FETCH_WEEKLY_PICKS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_WEEKLY_PICKS_FAILS,
          payload:error
        })
      })
  }
};

export const deleteWeeklyPicks = (country, spaceId) => {
  return dispatch =>{
    dispatch({
      type: Actions.DELETE_WEEKLY_PICKS
    });
    deleteSpace(`${space}/weekly-picks?country=${country}&spaceId=${spaceId}`)
    .then(res => {
      dispatch({
        type: Actions.DELETE_WEEKLY_PICK,
        payload: spaceId
      })
      toastr.success('Successfully deleted')
    })
    .catch(error => {
      if(error.response?.data?.errors?.length){
          for (let i = 0; i < error.response.data.errors.length; i++) {
              toastr.error(error.response.data.errors[i])
          }
      }else{
          toastr.error("Failed to delete")
      }
  });
  };
};

export const setWeeklyPicks = (weeklyPick) => {
  return dispatch => {
      dispatch({
        type: Actions.WEEKLYPICK_SUBMIT,
        payload:weeklyPick
      })
  }
};

export const updateWeeklyPick = (weeklyPick) => {
  return dispatch => {
      dispatch({
        type: Actions.WEEKLYPICK_UPDATE,
        payload:weeklyPick
      })
  }
};

export const clearSpaceDetails = () => {
  return {
    type: Actions.CLEAR_SPACEDETAILS,
  };
};

export const clearFilterSpaceName = () => {
  return {
    type: Actions.CLEAR_FILTERSPACENAME,
  };
};

export const checkSpaceInWeeklyPicks = (spaceId, country) => {
  return dispatch => {
    dispatch({
      type: Actions.CHECK_SPACE_IN_WEEKLY_PICKS
    });
    get(`${space}/weekly-picks?country=${country}`)
      .then(res => {
        const isSpaceInWeeklyPicks = res.data.some(pick => pick.id === spaceId);
        dispatch({
          type: Actions.CHECK_SPACE_IN_WEEKLY_PICKS_SUCCESS,
          payload: { spaceId, isUsed: isSpaceInWeeklyPicks }
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.CHECK_SPACE_IN_WEEKLY_PICKS_FAILS,
          payload: error
        });
      });
  };
};

export const clearSpaceWeeklyPicksCheck = () => {
  return {
    type: Actions.CLEAR_SPACE_WEEKLY_PICKS_CHECK,
  };
};

export const fetchSpacesStatus = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACES_STATUS
    });
    get(`api/space/status`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SPACES_STATUS_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SPACES_STATUS_FAILS,
          payload: error
        });
      });
  };
};

export const getSpaceFilterData = (page, size, country, status) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACESTATUSDATA
    });
    const url = `${space}?page=${page}&size=${size}&dataView=TABLE_VIEW&country=${country}`;
    get(url)
        .then(res => {
          dispatch({
            type: Actions.FETCH_SPACESTATUSDATA_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_SPACESTATUSDATA_FAILS,
            payload: error
          });
        });
  };
};

export const deleteNewWeeklyPick = (id) => {
  return dispatch => {
    dispatch({
      type: Actions.DELETE_WEEKLY_PICK,
      payload: id
    })
  }
};

export const saveWeeklyPicks = (country,payload,clearFields) => {
  return dispatch => {
    dispatch({
      type: Actions.SAVE_WEEKLY_PICKS
    });
    post(`${space}/weekly-picks/${country}`,payload)
    .then(res => {
      // dispatch({type: SAVE_WEEKLY_PICKS_SUCCESS})
      toastr.success('Successfully Added!');
       dispatch(getWeeklyPicks(country));
       clearFields();

    })
    .catch(error => {
      dispatch({
        type: Actions.SAVE_WEEKLY_PICKS_FAILS,
        payload:error

      })
      toastr.error('Failed to save')
    })
  }
};

export const updateStatus = (value, version, page, pageSize, email, country, status) => {
  return  dispatch => {
    dispatch({
      type: Actions.UPDATE_STATUS
    });
    const versionHeader = {'If-Match': version};

    put(`api/space/space-status`, value, versionHeader)
        .then(res => {
          toastr.success('Successfully saved');
          dispatch(getSpaceData(page, pageSize, email, country, status));

        })
        .catch(error => {
          toastr.error("Failed to save");
        });

  };
}

export const getMRTLocationData = () => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_MRT_LOCATIONS
    });
    const url = `${space}/nearby-locations?country=SG`;
    get(url)
        .then(res => {
          dispatch({
            type: Actions.FETCH_MRT_LOCATIONS_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_MRT_LOCATIONS_FAILS,
            payload: error
          });
        });
  };
};

export const getSpaceCategoryDetails = (country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACE_CATEGORY
    });
    get(`${space}/event-type-map?country=${country}`)
      .then(eventTypeResponse => {
        get(`${space}/space-category-map?country=${country}`)
          .then(spaceCategoryResponse => {
            const data = spaceCategoryResponse?.data.spaceCategories?.map(value => {
              return { ...value, venueType: eventTypeResponse?.data?.eventTypes?.filter(eventValue => eventValue?.spaceCategory?.id === value?.id) }
            })
            dispatch({
              type: Actions.FETCH_SPACE_CATEGORY_SUCCESS,
              payload: data
            });
          })
          .catch(error => {
            dispatch({
              type: Actions.FETCH_SPACE_CATEGORY_FAILS,
              payload: error
            });
          });
      })
  };
};

export const getPricingOptionsDayArray = (idList) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY
    });
    get(`${space}/pricing-options-map?chargingTypes=`+idList?.map(id =>id).toString())
      .then(res => {
        dispatch({
          type: Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY_SUCCESS,
          payload: res?.data?.map(value => {
            return { ...value, unit: idList?.find(itemListIndex => itemListIndex?.id === value?.chargingType)?.unit, name: idList?.find(itemListIndex => itemListIndex?.id === value?.chargingType)?.name }
          })
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY_FAILS,
          payload: error
        });
      });
  };
};

export const getSpacesByFilter = (spaceCategory, eventType, country) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_SPACES_BY_FILTER
    });
    
    const params = new URLSearchParams();
    if (spaceCategory) {
      params.append('spaceCategory', spaceCategory);
    }
    if (eventType) {
      params.append('eventType', eventType);
    }
    if (country) {
      params.append('country', country);
    }
    
    get(`api/search/map?${params.toString()}`)
      .then(res => {
        dispatch({
          type: Actions.FETCH_SPACES_BY_FILTER_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: Actions.FETCH_SPACES_BY_FILTER_FAILS,
          payload: error
        });
      });
  };
};